import type { StandardField } from './importTypes';

// Standard fields that can be mapped
// type: 'required' = mandatory fields, 'optional' = standard optional fields, 'custom' = organization-specific fields
// aliases: common CSV header variations that should map to this field
export const STANDARD_FIELDS: StandardField[] = [
  { value: 'first_name', label: 'First Name', type: 'required', aliases: ['firstname', 'first', 'fname'] },
  { value: 'last_name', label: 'Last Name', type: 'required', aliases: ['lastname', 'last', 'lname', 'surname'] },
  { value: 'email', label: 'Email', type: 'required', aliases: ['emailaddress', 'email_address', 'mail'] },
  { value: 'preferred_name', label: 'Preferred Name', type: 'optional', aliases: ['preferredname', 'nickname', 'preferred'] },
  { value: 'department', label: 'Department', type: 'optional', aliases: ['dept', 'division', 'team'] },
  { value: 'job_title', label: 'Job Title', type: 'optional', aliases: ['jobtitle', 'title', 'position'] },
  { value: 'employee_id', label: 'Employee ID', type: 'custom', aliases: ['employeeid', 'empid', 'emp_id', 'staffid'] },
  { value: 'location', label: 'Location', type: 'optional', aliases: ['office', 'city', 'site'] },
  { value: 'personality_type', label: 'i v e (Personality Type)', type: 'optional', aliases: ['ive', 'personality'] },
  { value: 'business_unit', label: 'opco (Business Unit)', type: 'optional', aliases: ['opco', 'businessunit', 'bu'] },
  { value: 'role', label: 'Role', type: 'optional' },
  { value: 'manager', label: 'Manager', type: 'optional', aliases: ['supervisor', 'reportsto'] },
  { value: 'manager_email', label: 'Manager Email', type: 'optional', aliases: ['manageremail', 'manager_email_address', 'supervisoremail'] },
  { value: 'level', label: 'Level', type: 'optional', aliases: ['grade', 'band'] },
  { value: 'dnm', label: 'DNM', type: 'optional' },
  { value: 'dnm_groupings', label: 'DNM Groupings', type: 'optional', aliases: ['dnmgroupings'] },
];

export const REQUIRED_FIELDS = STANDARD_FIELDS.filter((f) => f.type === 'required').map((f) => f.value);
